export default "__VITE_ASSET__B3HxRm8G__"